import { render, staticRenderFns } from "./RangchaList.vue?vue&type=template&id=b9d3843a&scoped=true"
import script from "./RangchaList.vue?vue&type=script&lang=js"
export * from "./RangchaList.vue?vue&type=script&lang=js"
import style0 from "./RangchaList.vue?vue&type=style&index=0&id=b9d3843a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d3843a",
  null
  
)

export default component.exports